import { combineReducers } from '@reduxjs/toolkit';
import { modalReducer } from '@/core/features/modal';
import { snackbarReducer } from '@/core/features/snackbar';
import { loaderReducer } from '@/core/features/loader';
import { demoReducer } from '@/slices/demo';
import { authReducer } from '@/slices/auth';
import { referenceDataReducer } from '@/slices/referenceData';
import { propertySearchReducer } from '@/slices/propertySearch';
import { favoritesReducer } from '@/slices/favorites';
import { myRequestsReducer } from '@/slices/myRequests';
import { notificationsReducer } from '@/slices/notifications';
import { adminItemsReducer } from '@/slices/adminItems';

const appReducer = combineReducers({
  modal: modalReducer,
  snackbar: snackbarReducer,
  loader: loaderReducer,
  demo: demoReducer,
  auth: authReducer,
  referenceData: referenceDataReducer,
  propertySearch: propertySearchReducer,
  favorites: favoritesReducer,
  myRequests: myRequestsReducer,
  notifications: notificationsReducer,
  adminItems: adminItemsReducer,
});

const rootReducer: typeof appReducer = (state, action) => {
  if (action.type === 'auth/clearAuth') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
